<template>
  <div class="header-line bg-dark">
    <strong>{{ title }}</strong>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Header text' }
  }
}
</script>
